import { COUNTRY_CODES } from "../../constants/countries";

const RBAC_COUNTRY = COUNTRY_CODES.PERU;

export const CAJERO_HIDDEN_MENU = ["3", "4", "4.1", "4.2", "5.4", "5.5", "6"];

const CAJERO_BLOCKED_ROUTES = new Set([
	"/consulta-stock",
	"/turnos",
	"/cajas",
	"/abonos",
	"/facturas-pendientes",
	"/informes",
]);

export const isCajero = (countryCode, isAdmin) =>
	countryCode === RBAC_COUNTRY && !isAdmin;

export const canAccessRoute = (countryCode, isAdmin, path) =>
	!isCajero(countryCode, isAdmin) || !CAJERO_BLOCKED_ROUTES.has(path);

export const getUserRoleLabel = (countryCode, isAdmin) => {
	if (isAdmin) return "Administrador";
	return isCajero(countryCode, isAdmin) ? "Usuario de caja" : "Usuario Regular";
};
